export const AuthTypes = {
  SET_USER_PROFILE: 'AUTH_SET_USER_PROFILE',
  LOGOUT: 'AUTH_LOGOUT'
};
